export function cloneArray<TItem>(array: TItem[]): TItem[] {
  return array.map((item) => ({ ...item }));
}
